import React from 'react'
import Strip1 from '../images/strip1cen.jpg'
import Strip2 from '../images/img53_censored.jpg'
import Strip3 from '../images/partitions.jpg'
import Strip4 from '../images/img (14).jpg'

export default function imageStripRetail() {
  return (
    <div className='row d-flex justify-content-center my-5'>
      <img src={Strip4} alt='Pic 1' style={{ maxHeight: '200px' }} />
      <img src={Strip1} alt='Pic 2' style={{ maxHeight: '200px' }} />
      <img src={Strip3} alt='Pic 4' style={{ maxHeight: '200px' }} />
      <img src={Strip2} alt='Pic 3' style={{ maxHeight: '200px' }} />
    </div>
  )
}
